

export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="py-12" style={{ backgroundColor: '#50686a' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="https://static.readdy.ai/image/ccbd9e92c2e4555bab62a0921318c3e7/db9c6e17f27c22a438cb358800367ea5.png" 
                alt="USAWA ADVISORY" 
                className="h-12 w-auto"
              />
            </div>
            <p className="font-light mb-4" style={{ color: '#98b8c1' }}>
              Where Equality Drives Opportunity
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-medium mb-4 text-white">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('home')}
                  className="font-light hover:opacity-80 transition-colors cursor-pointer text-white"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('sectors')}
                  className="font-light hover:opacity-80 transition-colors cursor-pointer text-white"
                >
                  Sectors
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="font-light hover:opacity-80 transition-colors cursor-pointer text-white"
                >
                  Our Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="font-light hover:opacity-80 transition-colors cursor-pointer text-white"
                >
                  About Us
                </button>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t pt-8 flex flex-col md:flex-row justify-between items-center" style={{ borderColor: '#607a7a' }}>
          <p className="font-light mb-4 md:mb-0" style={{ color: '#98b8c1' }}>
            © 2025 USAWA ADVISORY. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}